module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow--inactive@3x-fd3a9be7ddb011157671e727196a0497.png";